import { render, staticRenderFns } from "./StudentsWithDocumentsReport.vue?vue&type=template&id=002bae28&scoped=true&"
import script from "./StudentsWithDocumentsReport.vue?vue&type=script&lang=js&"
export * from "./StudentsWithDocumentsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002bae28",
  null
  
)

export default component.exports